export default __webpack_public_path__ + "static/media/filestor.d915fd6b.PNG";